export default "__VITE_PUBLIC_ASSET__41c643f2__"